import emailjs from '@emailjs/browser';

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

export function isEmailJsConfigured() {
  return Boolean(SERVICE_ID && TEMPLATE_ID && PUBLIC_KEY);
}

/**
 * Sends website contact / enquiry data via EmailJS.
 * Map these keys in your EmailJS template (e.g. {{from_name}}, {{message}}).
 * @param {object} data — use `company` and `service` (EnquiryForm can pass companyName/serviceInterest via spread).
 */
export async function sendContactFormEmail(data) {
  const {
    name,
    email,
    phone,
    company,
    companyName,
    service,
    serviceInterest,
    message
  } = data;

  if (!isEmailJsConfigured()) {
    throw new Error(
      'Email is not configured. Add REACT_APP_EMAILJS_SERVICE_ID, REACT_APP_EMAILJS_TEMPLATE_ID, and REACT_APP_EMAILJS_PUBLIC_KEY to your .env file and restart the app.'
    );
  }

  const templateParams = {
    from_name: name,
    from_email: email,
    reply_to: email,
    phone: phone || '—',
    company: (company ?? companyName) || '—',
    service: (service ?? serviceInterest) || '—',
    message: message || '—'
  };

  return emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, { publicKey: PUBLIC_KEY });
}
